import { createApp } from 'vue';
import App from '@/app/app.vue';

window.addEventListener('load', () => createApp(App).mount('#app'));
